

















































































import { WithdrawalsParams } from '@/store/interfaces/withdrawals';
import refundByTransfer from '@/store/types/withdrawals';
import { tTableColumns } from 'teip-components';
import StatusBadges from '@/components/Reusable/statusBadges.vue';
import refundConfirm from '@/components/modals/actionConfirm.vue';
import RefundModal from './modal/refund.vue';
import RefundDetail from './modal/detail.vue';
import { nameId } from '@/store/interfaces/generic';
import bankAccount from '@/store/types/bankAccount';
import { BankParams } from '@/store/interfaces/bankAccount';
import DatesFormat from '@/util/classes/datesFormat';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
const formatDate = new DatesFormat();

export default Vue.extend({
  name: 'RefundByTransfer',
  components: { StatusBadges, refundConfirm, RefundModal, RefundDetail, },
  data: () => ({
    tableColumns: [
      {
        prop: 'name',
        label: 'Usuario',
        minWidth: 250,
        formatter: (row: WithdrawalsParams): string => {
          return `${row.user_first_name} ${row.user_last_name}`;
        },
      },
      {
        prop: 'user_email',
        label: 'Correo',
        minWidth: 200,
        sortable: true,
      },
      {
        prop: 'total_formatted',
        label: 'Total retirado',
        minWidth: 150,
      },
      {
        prop: 'status',
        label: 'Estado',
        minWidth: 150,
        slotName: 'status',
      },
      {
        prop: 'bank_account_number',
        label: 'Cuenta bancaria',
        minWidth: 200,
        sortable: true,
      },
      {
        prop: 'bank_name',
        label: 'Banco',
        minWidth: 150,
        sortable: true,
      },
      {
        prop: 'created_at',
        label: 'Fecha y Hora',
        minWidth: 180,
        sortable: true,
        formatter: (row: WithdrawalsParams): string => {
          return `${formatDate.formatDateTime(row.created_at)}`;
        },
      }
    ] as tTableColumns,
    statusOptions: [
      { id: '', name: 'Todos', },
      { id: 'pending', name: 'Pendientes', },
      { id: 'success', name: 'Exitosos', },
      { id: 'failure', name: 'Fallidos', }
    ] as nameId[],
    searchQueryProp: '',
    refundByTransfer: {
      id: '',
      reference_number: '',
      account_id: '',
      amount_formatted: '',
      fee_formatted: '',
      total_formatted: '',
      status: 'pending',
      created_at: '',
      biometrics: false,
      bank_account_alias: '',
      bank_account_type: 'current',
      bank_account_number: '',
      bank_account_holder_first_name: '',
      bank_account_holder_last_name: '',
      bank_account_document_number: '',
      bank_name: '',
      bank_logo_url: '',
      user_id: '',
      user_email: '',
      user_first_name: '',
      user_last_name: '',
      user_handle: '',
      user_avatar_url: '',
      device_name: '',
      device_platform: '',
      device_version: '',
      device_vendor: '',
    } as WithdrawalsParams,
    showConfirmationRefundModal: false,
    showRefundModal: false,
    showDetail: false,
  }),
  computed: {
    ...mapGetters({
      getRefundByTransfer: `withdrawalsModule/${refundByTransfer.getters.GET_REFUND_BY_TRANSFER}`,
      getBanks: `companyModule/bankAccount/${bankAccount.getters.GET_BANKS_LIST}`,
    }),
    bankListFormatter(): nameId[] {
      return this.getBanks.map((bn: BankParams) => ({
        id: bn.id,
        name: bn.name,
      })) as nameId[];
    },
  },
  async mounted() {
    await this.bankList();
  },
  methods: {
    ...mapActions({
      refundByTransferFunction: `withdrawalsModule/${refundByTransfer.actions.REFUND_BY_TRANSFER_LIST}`,
      withdrawalsRefund: `withdrawalsModule/${refundByTransfer.actions.WITHDRAWALS_REFUND}`,
      bankList: `companyModule/bankAccount/${bankAccount.actions.BANKS_LIST}`,
    }),
    rowSelected(refund: WithdrawalsParams): void {
      this.refundByTransfer = refund;
    },
    async confirmRefund(): Promise<void> {
      await this.withdrawalsRefund(this.refundByTransfer.id);
      this.showConfirmationRefundModal = false;
    },
    drawalsSelected(row: WithdrawalsParams): void {
      this.refundByTransfer = row;
    },
    throwRefundModal(): void {
      this.showRefundModal = true;
    },
    showDetails(): void {
      this.showDetail = true;
    },
    withdrawalsQuerySearch(query: string): void {
      const q = query
        .replace('email_eq', 'user_email_eq')
        .replace('created_on', 'created_at');

      this.searchQueryProp = q ? `&${q}` : '';
    },
  },
});
